import React, { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { WatchedPageMessagesDefaultView } from './views/WatchedPageMessagesDefaultView';
import { WatchedPageMessagesEditView } from './views/WatchedPageMessagesEditView';
import {
  BlockInteractions,
  Views as BlockInteractionsViews,
  createButtonObject,
  DISPLAY_TYPE,
} from '../../components/organisms/BlockInteractions';
import { Namespace } from '../../translation/namespace';
import { BlockType } from '../../types/api/ElementType';
import { Icons } from '../../components/atoms/SVG';
import { asFetchableBlock, useBlockContext } from '../../_lib/BlockFetcher';
import { DefaultView, EditView, Views } from '../../types/BlockWithViews';

type WatchedPageMessagesProps = Views<
  DefaultView<WatchedPageMessagesDefaultView> & EditView<WatchedPageMessagesEditView>
>;
function WatchedPageMessages({ activeView = 'default', views }: WatchedPageMessagesProps) {
  const { t } = useTranslation(Namespace.WatchedPageMessagesPanel);

  const { elementType, uuid } = useBlockContext();

  const headline = {
    text: t('headline'),
    hierarchy: 4,
    visible: true,
  };

  const createButtonsObject = () => {
    return createButtonObject(
      BlockInteractionsViews.EDIT,
      Icons.EDIT_PENCIL,
      `${Namespace.WatchedPageMessagesPanel}:edit`,
      DISPLAY_TYPE.COLLAPSIBLE,
      <WatchedPageMessagesEditView {...views.edit} />,
    );
  };
  return (
    <BlockInteractions
      headline={headline}
      alwaysShowInfo
      views={views}
      activeView={activeView}
      buttons={createButtonsObject()}
      uuid={uuid}
      elementType={elementType}
    >
      <WatchedPageMessagesDefaultView {...views.default} />
    </BlockInteractions>
  );
}

export const WatchedPageMessagesBlock = asFetchableBlock(
  WatchedPageMessages,
  BlockType.watchedpagemessagesblock,
  BlockType.watchedpagemessagesblock,
);
export type WatchedPageMessagesBlock = ComponentProps<typeof WatchedPageMessagesBlock>;
